<template>
  <div class="mypage-top-page">
    <membership-card-pane
      :enabledListCarousel="enabledListCarousel"
      :isEditCardForHighlightComment="isEditCardForHighlightComment"
    />

    <mypage-top-pane class="mypage-top-page__content" @error-move="moveToLogin" />
    <global-navigation-pane class="mypage-top-page__navigation" current="mypage" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api'
import MembershipCardPane from '@/components/MypageTopPage/MembershipCardPane.vue'
import MypageTopPane from '@/components/MypageTopPage/MypageTopPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'

/**
 * マイページ: トップページ
 */
export default defineComponent({
  name: 'MypageTopPage',
  components: {
    MembershipCardPane,
    GlobalNavigationPane,
    MypageTopPane,
  },
  props: {
    enabledListCarousel: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    /**
     * 会員証を編集モードで表示するかどうか
     * ハイライトコメントを入力しようとした際、SFgo用ニックネームが未入力だった場合にtrueになる
     */
    const isEditCardForHighlightComment = ref(false)

    return {
      isEditCardForHighlightComment,
    }
  },
  created() {
    const query = this.$route.query.isEditCard
    if (query && query === 'true') {
      this.isEditCardForHighlightComment = true
    }
  },
  methods: {
    /**
     * ログインページへ遷移
     * @event error-move
     */
    moveToLogin() {
      this.$router.replace({ path: '/login' })
    },
  },
})
</script>

<style lang="scss" scoped>
.mypage-top-page {
  position: relative;
  width: 100%;
  height: calc(100vh - #{$headerPaneHeight} - #{var(--safe-area-inset-bottom)});
  overflow-y: auto;
  overflow-x: hidden;

  &__content {
    padding-bottom: $globalNavigationHeight;
  }

  &__navigation {
    position: fixed;
    bottom: var(--safe-area-inset-bottom);
    left: 0;
  }
}
</style>
